import {createResourceSelector} from 'src/shared/utils/resource';
import {createSelector} from 'reselect';
import {resourceStatus} from 'src/shared/resourceStatus/selectors';

export const smsEnrollment = createResourceSelector('smsEnrollment');
export const outageSmsEnrollment = createResourceSelector('outageSmsEnrollment');

export const succesfullyEnrolled = createSelector(
  [smsEnrollment, resourceStatus],
  (smsEnrollment, resourceStatus) =>
    !!(!resourceStatus?.error?.smsEnrollment && smsEnrollment.enrolledInSmsUpdates)
);

export const outageSmsEnrollmentStatus = createSelector(
  outageSmsEnrollment,
  outageSmsEnrollment => outageSmsEnrollment.status
);
